import Vuex from 'vuex';

import account from '@/store/modules/account';
import consumer from '@/store/modules/consumer';
import homepage from '@/store/modules/homepage';
import jobrequest, { JobRequestPlugins } from '@/store/modules/jobrequest';
import prohub from '@/store/modules/prohub';
import user from '@/store/modules/user';
import loginspoof from '@/store/modules/loginspoof';
import propublicprofile from '@/store/modules/propublicprofile';
import warnings, { WarningsPlugins } from '@/store/modules/warnings';
import dashboard from '@/store/modules/dashboard';
import entities from '@/store/modules/entities';
import ui from '@/store/modules/ui';
import fullproprofile from '@/store/modules/fullproprofile';
import auth from '@/store/modules/auth';
import riskAssesment from '@/store/modules/riskAssesment';
import recaptcha from './modules/recaptcha';

const modules = {
  account,
  consumer,
  homepage,
  jobrequest,
  prohub,
  user,
  loginspoof,
  propublicprofile,
  warnings,
  dashboard,
  entities,
  ui,
  fullproprofile,
  auth,
  recaptcha: recaptcha(),
  riskAssesment: riskAssesment(),
};

export function createStore ({ plugins = [] }) {
  const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules,
    plugins: [
      ...plugins,
      ...JobRequestPlugins,
      ...WarningsPlugins,
    ],
  });

  return store;
}
